import React, { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import ModalAllder from 'components/layout/ModalAllder';
import Switch from '@mui/material/Switch';

const COLUMN_LIST = [
    { key: 'vat',    label: 'มูลค่าภาษี' },
    { key: 'remark', label: 'หมายเหตุ' },
];

export default function ModalColumnDisplay({ modal, setModal, column, setColumn }) {
    const [selectedColumn, setSelectedColumn] = useState(column);

    // sync draft state ทุกครั้งที่ modal เปิด
    useEffect(() => {
        if (modal.open) {
            setSelectedColumn(column);
        }
    }, [modal.open, column]);

    const handleConfirm = () => {
        setColumn(selectedColumn);
        localStorage.setItem('columdisplay', JSON.stringify(selectedColumn));
        setModal((prev) => ({ ...prev, open: false }));
    };

    const handleCancel = () => {
        setSelectedColumn(column); // restore ค่าเดิม
        setModal((prev) => ({ ...prev, open: false }));
    };

    return (
        <>
            <ModalAllder modal={modal} setModal={setModal} htitle={'ตัวเลือกการแสดงผล'} hbtn={true}>
                <div className="py-3"></div>
                <Table
                    sx={{
                        maxWidth: 750,
                        color: '#4C4E64DE',
                        '& .MuiTableCell-root': {
                            border: '1px solid rgba(224, 224, 224, 1)',
                            padding: '10px',
                        },
                    }}
                >
                    <TableHead>
                        <TableRow style={{ background: '#e5e5e585' }}>
                            <TableCell align="center" className="!py-4" width={'30%'}>
                                สถานะ
                            </TableCell>
                            <TableCell align="center">รายการแสดงผล</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {COLUMN_LIST.map((col) => (
                            <TableRow key={col.key} style={{ background: 'white' }}>
                                <TableCell align="center">
                                    <Switch
                                        checked={!!selectedColumn[col.key]}
                                        onChange={(e) =>
                                            setSelectedColumn((prev) => ({
                                                ...prev,
                                                [col.key]: e.target.checked,
                                            }))
                                        }
                                    />
                                </TableCell>
                                <TableCell align="center" className="!text-[#4C4E64DE]">
                                    {col.label}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

                <div className="text-right mt-7">
                    <Button
                        variant="contained"
                        color="primary"
                        className="!px-10 !mr-4"
                        onClick={handleConfirm}
                    >
                        ยืนยัน
                    </Button>
                    <Button
                        variant="outlined"
                        color="gray"
                        className="!px-10"
                        onClick={handleCancel}
                    >
                        ยกเลิก
                    </Button>
                </div>
            </ModalAllder>
        </>
    );
}
